import React, { useEffect, useMemo, useState } from 'react';

function prefersReducedMotion() {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function SuccessBurst({ trigger }) {
  const [isActive, setIsActive] = useState(false);

  const particles = useMemo(() => {
    // Deterministic pattern: no Math.random so it looks consistent and avoids flicker.
    const count = 18;
    const out = [];
    for (let i = 0; i < count; i += 1) {
      const angle = (i / count) * 360;
      const delay = (i % 6) * 0.012;
      const hue = 210 + (i % 5) * 22; // blue -> amber-ish
      const dist = 70 + (i % 4) * 10;
      out.push({ angle, delay, hue, dist, i });
    }
    return out;
  }, []);

  useEffect(() => {
    if (!trigger) return;
    if (prefersReducedMotion()) return;

    setIsActive(true);
    const t = window.setTimeout(() => setIsActive(false), 780);
    return () => window.clearTimeout(t);
  }, [trigger]);

  if (!isActive) return null;

  return (
    <div className="cm-burst" aria-hidden="true">
      {particles.map((p) => (
        <span
          key={p.i}
          className="cm-burst-p"
          style={{
            '--a': `${p.angle}deg`,
            '--d': `${p.dist}px`,
            '--dl': `${p.delay}s`,
            '--h': p.hue
          }}
        />
      ))}
      <div className="cm-burst-ring" />
    </div>
  );
}

export default SuccessBurst;

